import UserFirstProfile from "../../../../Utils/CommonComponents/CommonUserProfile/UserFirstProfile";
import UserFifthProfile from "./UserFifthProfile";
import UserFourthProfile from "./UserFourthProfile";
import UserSecondProfile from "./UserSecondProfile";
import UserThirdProfile from "./UserThirdProfile";

export default function TourMain() {
  return (
    <>
      <UserFirstProfile />
      <UserSecondProfile />
      <UserThirdProfile />
      <UserFourthProfile />
      <UserFifthProfile />
    </>
  );
}
